import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

const OtaSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    code: z.string(),
    name: z.string(),
    primary_color: z.string(),
    secondary_color: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

export const OtaResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(OtaSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type OtaResponse = z.infer<typeof OtaResponseSchema>;
export type OtaSingleResponse = z.infer<typeof OtaSchema>;
